import React from "react"
import { graphql, StaticQuery } from "gatsby"

import Layout from "../components/Layout"
import Seo from "../components/Seo"

import "../utils/normalize.css"
import "../utils/css/screen.css"
import { Box, Heading, Link } from "@chakra-ui/react"

function ContactPage({ data }) {
  const { siteMetadata } = data.site || {}
  const { title, strapiUrl, siteUrl } = siteMetadata || {}
  return (
    <Layout
      duration={"0"}
      delay={"0"}
      title={title}
      strapiUrl={strapiUrl}
      logo={`${strapiUrl}/uploads/bitlight_logo_B2_2b1b649637.png`}
      backgroundColor={"#FFD600"}
      siteUrl={siteUrl}
    >
      <Seo
        title={"Cookie policy"}
        keywords={["bitlight", "privacy", "policy", "cookie", "cookies"]}
      />
      <Box fontFamily={"GT Walsheim"} p={"16px"} maxW={"1600px"} margin={"auto"}>
        <div>
          <Heading fontFamily={"GT Walsheim"}><strong><span>COOKIE POLICY</span></strong></Heading>
          <p><span>&nbsp;</span></p>
          <p><strong><span>Last updated&nbsp;October 20, 2021</span></strong></p>
          <p><span>&nbsp;</span></p>
          <p><span>&nbsp;</span></p>
          <p><span>&nbsp;</span></p>
          <p><span>This Cookie Policy explains how&nbsp;Bitlight d.o.o.&nbsp;("<strong>Company</strong>", "<strong>we</strong>", "<strong>us</strong>", and "<strong>our</strong>") uses cookies and similar technologies to recognize you when you visit our websites at <Link color={"rgb(255, 214, 0)"} href={"https://bitlight.dev/"} target={"_blank"} rel={"noreferrer"}><span>https://bitlight.dev</span></Link>,&nbsp;("<strong>Websites</strong>"). It explains what these technologies are and why we use them, as well as your rights to control our use of them.</span></p>
          <p><span>&nbsp;</span></p>
          <p><span>In some cases we may use cookies to collect personal information, or that becomes personal information if we combine it with other information.</span></p>
          <p><span>&nbsp;</span></p>
          <p><strong><span>What are cookies?</span></strong></p>
          <p><span>&nbsp;</span></p>
          <p><span>Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners in order to make their websites work, or to work more efficiently, as well as to provide reporting information.</span></p>
          <p><span>&nbsp;</span></p>
          <p><span>Cookies set by the website owner (in this case,&nbsp;Bitlight d.o.o.) are called "first party cookies". Cookies set by parties other than the website owner are called "third party cookies". Third party cookies enable third party features or functionality to be provided on or through the website (e.g. like advertising, interactive content and analytics). The parties that set these third party cookies can recognize your computer both when it visits the website in question and also when it visits certain other websites.</span></p>
          <p><span>&nbsp;</span></p>
          <p><strong><span>Why do we use cookies?</span></strong></p>
          <p><span>&nbsp;</span></p>
          <p><span>We use first&nbsp;and third&nbsp;party cookies for several reasons. Some cookies are required for technical reasons in order for our Websites to operate, and we refer to these as "essential" or "strictly necessary" cookies. Other cookies also enable us to track and target the interests of our users to enhance the experience on our Online Properties.&nbsp;Third parties serve cookies through our Websites for advertising, analytics and other purposes.&nbsp;This is described in more detail below.</span></p>
          <p><span>&nbsp;</span></p>
          <p><span>The specific types of first&nbsp;and third&nbsp;party cookies served through our Websites and the purposes they perform are described below (please note that the specific cookies served may vary depending on the specific Online Properties you visit):</span></p>
          <p><span>&nbsp;</span></p>
          <p><strong><span>How can I control cookies?</span></strong></p>
          <p><span>&nbsp;</span></p>
          <p><span>You have the right to decide whether to accept or reject cookies. You can exercise your cookie rights by setting your preferences in the Cookie Consent Manager. The Cookie Consent Manager allows you to select which categories of cookies you accept or reject. Essential cookies cannot be rejected as they are strictly necessary to provide you with services.</span></p>
          <p><span>&nbsp;</span></p>
          <p><span>The Cookie Consent Manager can be found in the notification banner and on our website. If you choose to reject cookies, you may still use our website though your access to some functionality and areas of our website may be restricted. You may also set or amend your web browser controls to accept or refuse cookies. As the means by which you can refuse cookies through your web browser controls vary from browser-to-browser, you should visit your browser's help menu for more information.</span></p>
          <p><span>&nbsp;</span></p>
          <p><span>In addition, most advertising networks offer you a way to opt out of targeted advertising. If you would like to find out more information, please visit&nbsp;</span><span><a href={"http://www.aboutads.info/choices/"} target={"_blank"} rel={"noreferrer"}><span>http://www.aboutads.info/choices/</span></a></span><span>&nbsp;or&nbsp;</span><span><a href={"http://www.youronlinechoices.com/"} target={"_blank"} rel={"noreferrer"}><span>http://www.youronlinechoices.com</span></a></span><span>.</span></p>
          <p><span>&nbsp;</span></p>
          <p><span>The specific types of first and third party cookies served through our Websites and the purposes they perform are described in the table below (please note that the specific&nbsp;cookies served may vary depending on the specific Online Properties you visit):</span><strong><br/><br/><span>Essential website cookies:</span></strong></p>
          <p><span>These cookies are strictly necessary to provide you with services available through our Websites and to use some of its features, such as access to secure areas.</span></p>
          <table>
            <tbody>
              <tr>
                <td>
                  <p><span>Name:</span></p>
                </td>
                <td>
                  <p><span>__tlbcpv</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>Purpose:</span></p>
                </td>
                <td>
                  <p><span>Used to record unique visitor views of the consent banner.</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>Provider:</span></p>
                </td>
                <td>
                  <p><span>.termly.io</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>Service:</span></p>
                </td>
                <td>
                  <p><span>Termly <a href={"https://termly.io/our-privacy-policy/"} target={"_blank"} rel={"noreferrer"}><span>View Service Privacy Policy</span></a></span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>Country:</span></p>
                </td>
                <td>
                  <p><span>United States</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>Type:</span></p>
                </td>
                <td>
                  <p><span>http_cookie</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>Expires in:</span></p>
                </td>
                <td>
                  <p><span>1 year</span></p>
                </td>
              </tr>
            </tbody>
          </table>
          <p><strong><span>Analytics and customization cookies:</span></strong></p>
          <p><span>These cookies collect information that is used either in aggregate form to help us understand how our Websites are being used or how effective our marketing campaigns are, or to help us customize our Websites for you.</span></p>
          <table>
            <tbody>
              <tr>
                <td>
                  <p><span>Name:</span></p>
                </td>
                <td colSpan={3}>
                  <p><span>_ga</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>Purpose:</span></p>
                </td>
                <td colSpan={3}>
                  <p><span>It records a particular ID used to come up with data about website usage by the user. It is a HTTP cookie that expires after 2 years.</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>Provider:</span></p>
                </td>
                <td colSpan={3}>
                  <p><span>.bitlight.dev</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>Service:</span></p>
                </td>
                <td colSpan={3}>
                  <p><span>Google Analytics <a href={"https://policies.google.com/technologies/ads"} target={"_blank"} rel={"noreferrer"}><span>View Service Privacy Policy</span></a></span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>Country:</span></p>
                </td>
                <td colSpan={3}>
                  <p><span>India</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>Type:</span></p>
                </td>
                <td colSpan={3}>
                  <p><span>http_cookie</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><span>Expires in:</span></p>
                </td>
                <td colSpan={3}>
                  <p><span>1 year 11 months 29 days</span></p>
                </td>
              </tr>

            </tbody>
          </table>
          <table>
            <tbody>
              <tr>
                <td colSpan={3}>
                  <p><span>Name:</span></p>
                </td>
                <td>
                  <p><span>_gat</span></p>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <p><span>Purpose:</span></p>
                </td>
                <td>
                  <p><span>Used to monitor number of Google Analytics server requests when using Google Tag Manager</span></p>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <p><span>Provider:</span></p>
                </td>
                <td>
                  <p><span>.bitlight.dev</span></p>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <p><span>Service:</span></p>
                </td>
                <td>
                  <p><span>Google Analytics <a href={"https://policies.google.com/technologies/ads"} target={"_blank"} rel={"noreferrer"}><span>View Service Privacy Policy</span></a></span></p>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <p><span>Country:</span></p>
                </td>
                <td>
                  <p><span>India</span></p>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <p><span>Type:</span></p>
                </td>
                <td>
                  <p><span>http_cookie</span></p>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <p><span>Expires in:</span></p>
                </td>
                <td>
                  <p><span>1 minute</span></p>
                </td>
              </tr>
            </tbody>
          </table>
          <table>
            <tbody>
              <tr>
                <td colSpan={3}>
                  <p><span>Name:</span></p>
                </td>
                <td>
                  <p><span>_gid</span></p>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <p><span>Purpose:</span></p>
                </td>
                <td>
                  <p><span>Keeps an entry of unique ID which is then used to come up with statistical data on website usage by visitors. It is a HTTP cookie type and expires after a browsing session.</span></p>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <p><span>Provider:</span></p>
                </td>
                <td>
                  <p><span>.bitlight.dev</span></p>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <p><span>Service:</span></p>
                </td>
                <td>
                  <p><span>Google Analytics <a href={"https://policies.google.com/technologies/ads"} target={"_blank"} rel={"noreferrer"}><span>View Service Privacy Policy</span></a></span></p>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <p><span>Country:</span></p>
                </td>
                <td>
                  <p><span>India</span></p>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <p><span>Type:</span></p>
                </td>
                <td>
                  <p><span>http_cookie</span></p>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <p><span>Expires in:</span></p>
                </td>
                <td>
                  <p><span>1 day</span></p>
                </td>
              </tr>
            </tbody>
          </table>
          <p><span>&nbsp;</span></p>
          <p><strong><span>What about other tracking technologies, like web beacons?</span></strong></p>
          <p><span>&nbsp;</span></p>
          <p><span>Cookies are not the only way&nbsp;to recognize or track visitors to a website. We may use other, similar technologies from time to time, like web beacons (sometimes called "tracking pixels" or "clear gifs"). These are tiny graphics files that contain a unique identifier that enable us to recognize when someone has visited our Websites&nbsp;or opened an e-mail including them. This allows us, for example, to monitor&nbsp;the traffic patterns of users from one page within a website to another, to deliver or communicate with cookies, to understand whether you have come to the website from an online advertisement displayed on a third-party website, to improve site performance, and to measure the success of e-mail marketing campaigns. In many instances, these technologies are reliant on cookies to function properly, and so declining cookies will impair their functioning.</span></p>
          <p><span>&nbsp;</span></p>
          <p><strong><span>Do you use Flash cookies or Local Shared Objects?</span></strong></p>
          <p><span>&nbsp;</span></p>
          <p><span>Websites may also use so-called "Flash Cookies" (also known as Local Shared Objects or "LSOs") to, among other things, collect and store information about your use of our services, fraud prevention and for other site operations.</span></p>
          <p><span>&nbsp;</span></p>
          <p><span>If you do not want Flash Cookies stored on your computer, you can adjust the settings of your Flash player to block Flash Cookies storage using the tools contained in the&nbsp;</span><span><a href={"http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html"} target={"_BLANK"} rel={"noreferrer"}><span>Website Storage Settings Panel</span></a></span><span>. You can also control Flash Cookies by going to the&nbsp;</span><span><a href={"http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager03.html"} target={"_BLANK"} rel={"noreferrer"}><span>Global Storage Settings Panel</span></a></span><span>&nbsp;and following the instructions (which may include instructions that explain, for example, how to delete existing Flash Cookies (referred to "information" on the Macromedia site), how to prevent Flash LSOs from being placed on your computer without your being asked, and (for Flash Player 8 and later) how to block Flash Cookies that are not being delivered by the operator of the page you are on at the time).</span></p>
          <p><span>&nbsp;</span></p>
          <p><span>Please note that setting the Flash Player to restrict or limit acceptance of Flash Cookies may reduce or impede the functionality of some Flash applications, including, potentially, Flash applications used in connection with our services or online content.</span></p>
          <p><span>&nbsp;</span></p>
          <p><strong><span>Do you serve targeted advertising?</span></strong></p>
          <p><span>&nbsp;</span></p>
          <p><span>Third parties may serve cookies on your computer or mobile device to serve advertising through our Websites. These companies may use information about your visits to this and other websites in order to provide relevant advertisements about goods and services that you may be interested in. They may also employ technology that is used to measure the effectiveness of advertisements. This can be accomplished by them using cookies or web beacons to collect information about your visits to this and other sites in order to provide relevant advertisements about goods and services of potential interest to you. The information collected through this process does not enable us or them to identify your name, contact details or other details that directly identify you unless you choose to provide these.</span></p>
          <p><span>&nbsp;</span></p>
          <p><strong><span>How often will you update this Cookie Policy?</span></strong></p>
          <p><span>&nbsp;</span></p>
          <p><span>We may update&nbsp;this Cookie Policy from time to time in order to reflect, for example, changes to the cookies we use or for other operational, legal or regulatory reasons. Please therefore re-visit this Cookie Policy regularly to stay informed about our use of cookies and related technologies.</span></p>
          <p><span>&nbsp;</span></p>
          <p><span>The date at the top of this Cookie Policy indicates when it was last updated.</span></p>
          <p><span>&nbsp;</span></p>
          <p><strong><span>Where can I get further information?</span></strong></p>
          <p><span>&nbsp;</span></p>
          <p><span>If you have any questions about our use of cookies or other technologies, please email us at&nbsp;info@bitlight.dev&nbsp;or by post to:</span></p>
          <p><span><br />&nbsp;</span></p>
          <p><span>Bitlight d.o.o.</span></p>
          <p><span>Zagrebacka cesta 126, 10090, Zagreb, Croatia</span></p>
          <p><span>Zagreb,&nbsp;Grad Zagreb&nbsp;10090</span></p>
          <p><span>Croatia</span></p>
          <p><span>Phone:&nbsp;(+385)916554005</span></p>
        </div>
      </Box>
    </Layout>
  )
}

const indexQuery = graphql`
    query {
        site {
            siteMetadata {
                title
                author
                strapiUrl
                siteUrl
            }
        }
    }
`

function StaticContactPage(props) {
  return (
    <StaticQuery
      query={indexQuery}
      render={data => (
        <ContactPage location={props.location} data={data} {...props} />
      )}
    />
  )
}

export default StaticContactPage
